import React from 'react';
import {JAVASCRIPT_VOID} from 'constants/config';
import Dim from 'components/common/Dim';
import {t} from 'lib/i18n';

/**
 * 허용 브라우저 체크 컴포넌트
 */

const CheckBrowser = () => {
  /**
   * 닫기 버튼 클릭 함수
   */
  const onClickClose = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();

    window.close();
  };

  return (
    <>
      <Dim />
      <div className='unsupported'>
        <em></em>
        <p>{t('해당 브라우저는 VOD 편집기 서비스를 지원하지 않습니다')}</p>
        <div className='support'>
          <span>{t('지원 브라우저')}</span>
          <div>
            <b>{t('엣지')}</b>
            <b>{t('크롬')}</b>
            <b>{t('웨일')}</b>
          </div>
        </div>
        <p>{t('엣지는 크로미움 기반 브라우저에서만 이용 가능합니다.')}</p>
        <a href={JAVASCRIPT_VOID} onClick={onClickClose}>
          {t('닫기')}
        </a>
      </div>
    </>
  );
};

export default CheckBrowser;
